import ModernSettingHeader from '../../../components/settings/ModernSettingHeader';
import SwitchAccount from './SwitchAccount';
import { Users } from 'lucide-react';

const AccountsSettingsPage = () => {
    return (
        <div className="w-full">
            <ModernSettingHeader
                title="User Accounts"
                description="Manage your account access and switch between different accounts"
                icon={<Users className="h-5 w-5" />}
            />
            <div className="p-6">
                <SwitchAccount />
            </div>
        </div>
    );
};

export default AccountsSettingsPage;